import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
// eslint-disable-next-line import/no-cycle
import FormDefinitionRenderer from "../FormDefinitionRenderer/FormDefinitionRenderer.jsx";

export default function AccordionControl({ item }) {
  return (
    <Accordion defaultExpanded={item.expanded ?? false}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography>{item.label}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <FormDefinitionRenderer fields={item.children} />
      </AccordionDetails>
    </Accordion>
  );
}
